<template>
    <div id="resource-share">
        <div class="container">
            <div class="header-container">
                <img class="header-logo" src="@/assets/logo.svg" alt="North Coast Resource Hub">
            </div>
            <div class="row no-print">
                <div class="col">
                    <router-link to="/">Search For More Resources</router-link>
                </div>
            </div>
            <div class="row">
                <div class="col" id="search-list-container">
                    <main role="main" class="main-resources container">
                            <div class="row">
                                <div class="col-12">
                                    <div v-if="!isPrint">
                                        <div class="detail-block no-print" v-for="resource in resourcesPage" v-bind:key="resource.idResource">
                                            <div class="detail-header">
                                                <h3>{{resource.name}}</h3>
                                            </div>
                                            <div class="detail-body container-fluid">
                                                <div class="row">
                                                    <div class="detail-desc col-12">{{resource.description}}</div>
                                                    <div class="detail-addr col-sm">
                                                        <div class="detail-body-subhead" >
                                                            <span v-if="resource.addressNote">{{resource.addressNote}}</span>
                                                            <span v-else>Address</span>
                                                        </div>
                                                        <div class="detail-addr-body" v-if="resource.physicalAddress == 1 || resource.physicalAddress == 2">{{resource.address}}<br />{{resource.city}}, {{resource.state}} {{resource.zip}}</div>
                                                    </div>
                                                    <div class="detail-phone col-sm" v-if="resource.phone">
                                                        <div class="detail-body-subhead">Phone</div>
                                                        <div>{{resource.phone | phoneNum}}</div>
                                                    </div>
                                                    <div class="detail-links col-sm">
                                                        <a v-show="resource.website" class="btn btn-sm btn-secondary" v-bind:href="urlify(resource.website)" target="_blank" :aria-label="resource.name + ' website'">Website Link</a>
                                                        <router-link v-bind:to="'/detail/' + resource.idResource" class="btn btn-sm btn-primary">More Details</router-link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isPrint">
                                        <div class="detail-block" v-for="resource in resourcesPage" v-bind:key="resource.idResource + 'print'">
                                            <div class="detail-header">
                                                <h3>{{resource.name}}</h3>
                                            </div>
                                            <div class="detail-body container-fluid">
                                                <div class="row">
                                                    <div class="detail-desc col-12">{{resource.description}}</div>
                                                    <div class="detail-addr col-sm">
                                                        <div class="detail-body-subhead">
                                                            <span v-if="resource.addressNote">{{resource.addressNote}}</span>
                                                            <span v-else>Address</span>
                                                        </div>
                                                        <div class="detail-addr-body" v-if="resource.physicalAddress == 1 || resource.physicalAddress == 2">{{resource.address}}<br />{{resource.city}}, {{resource.state}} {{resource.zip}}</div>
                                                    </div>
                                                    <div class="detail-phone col-sm" v-if="resource.phone">
                                                        <div class="detail-body-subhead">Phone</div>
                                                        <div>{{resource.phone | phoneNum}}</div>
                                                    </div>
                                                    <div class="detail-links col-12" v-if="resource.website">
                                                        <div class="detail-body-subhead">
                                                            Website
                                                        </div>
                                                        <div>{{resource.website}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </main>
                </div>
            </div>
            <div id="translateCheck" style="color: transparent;">This page has been translated</div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Share",
        data(){
            return {
                resourcesPage: [],
                isPrint: false,
                hasTranslate: false,
                translateCheck: ""
            }
        },
        mounted() {
            window.addEventListener("beforeprint", (e)=>{
                this.isPrint = true
                this.$forceUpdate()
            });

            window.addEventListener("afterprint", (e)=>{
                this.isPrint = false;
                this.$forceUpdate()
            })
            let options = {};

            if(this.$route.query.ids){
                options = {
                    params: {
                        ids: this.$route.query.ids
                    }
                }
            }
            if(location.hash.indexOf("googtrans")>-1){
                this.hasTranslate = true;
                this.translateCheck = document.getElementById("translateCheck").innerText;
            }
            axios.get("/api/resource.php", options)
                .then(response => {
                    if (response.data){
                        this.resourcesPage = response.data;
                        if(this.$route.query.print === "1"){
                            this.isPrint = true;
                            if(this.hasTranslate){
                                this.waitForTranslate()
                            } else {
                                this.$nextTick(() => {
                                    console.log("first print");
                                    window.print();
                                })
                            }
                        }
                    }
                });
        },
        methods: {
            urlify(website){
                if(website.toLowerCase().substring(0,4) === "http"){
                    return website;
                }
                else {
                    return "//" + website;
                }
            },
            waitForTranslate(){
                if(document.querySelector("html").classList.contains("translated-ltr")){
                    if(this.translateCheck !== document.getElementById("translateCheck").innerText){
                        this.$nextTick(()=>{
                            setTimeout(()=>{
                                this.$forceUpdate();
                                this.$nextTick(()=>{
                                    window.print()
                                })
                            }, 1000)
                        })
                    } else {
                        setTimeout(this.waitForTranslate, 100);
                    }
                } else {
                    setTimeout(this.waitForTranslate, 100);
                }
                /*
                let tFrame = document.getElementById(":1.container");
                if(tFrame){
                    let t = tFrame.contentWindow.document.getElementById(":1.finishTargetLang")
                    if(t){
                        if(t.style.display !== "none"){
                            this.$nextTick(()=>{
                                window.print();
                            })
                        } else {
                            setTimeout(this.waitForTranslate, 100);
                        }
                    } else {
                        setTimeout(this.waitForTranslate, 100);
                    }
                } else {
                    setTimeout(this.waitForTranslate, 100);
                }

                 */
            }
        }
    }
</script>

<style scoped>

</style>